import React from 'react'
import './Programs.css'
import RightArrow from '../../assets/rightArrow.png' // Assuming you have a right arrow image
import { programsData } from '../../data/programsData' // Assuming you have a data file for programs
const Programs = () => {
    return (
        <div className="Programs" id="Programs">
            <div className="Programs-header">
                <span className="stroke-text">
                    Explore Our
                </span>
                <span>Programs</span>
                <span className="stroke-text">To Shape You</span>
            </div>
            <div className="program-categories">
                {programsData.map((program) => (
                    <div className="category">
                        {program.image}
                        <span>{program.heading}</span>
                        <span>{program.details}</span>
                        <div className="join-now"><span>join-now</span>
                            <img src={RightArrow} alt='right arrow' />
                        </div>
                    </div>
                ))}

            </div>
        </div>
    )
}

export default Programs
